import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";

const UnlockedCars = () => {
  const [approvedList, setApprovedList] = useState([]);
  const [contactInfo, setContactInfo] = useState();
  const [pageLoading, setPageLoading] = useState(true);

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/bidder/accepetd/bids",
        {
          bidder_id: storedUserPreferences?.id,
        }
      );

      setApprovedList(response?.data.biddings);
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  useEffect(() => {
    fetchData();
  }, []);
  function backto() {
    window.history.back();
  }
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h3 className="cl-page-title">Unlocked Cars</h3>
              <p className="cl-page-subtitle">Cars you've successfully unlocked</p>
            </div>
            <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left"></i>Back
            </button>
          </div>
          {pageLoading ? (
            <SkeletonCard count={8} />
          ) : (
          <div className="row g-3">
            {approvedList?.length === 0 ? (
              <div className="col-12">
                <div className="cl-empty">
                  <div className="cl-empty-icon"><i className="fa-solid fa-lock-open"></i></div>
                  <h6 className="cl-empty-title">No Unlocked Cars</h6>
                  <p className="cl-empty-text">Cars that you have successfully unlocked will appear here.</p>
                </div>
              </div>
            ) : (
              approvedList?.map((car) => (
                <div
                  key={car?.id}
                  className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                >
                  <CarCard
                    carData={car?.car}
                    extraBodyContent={
                      <div className="mt-1 pt-1" style={{ borderTop: "1px solid #e5e7eb" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Offer</span>
                          <span className="fw-bold text-truncate text-end" style={{ fontSize: "12px", color: "#00889c", maxWidth: "60%" }}>£{formatEuroAmount(car.amount)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Request</span>
                          <span className="fw-semibold text-capitalize text-truncate text-end" style={{ fontSize: "10px", color: "#00889c", maxWidth: "60%" }}>{car.bid_request}</span>
                        </div>
                        <div className="d-flex justify-content-center">
                          <button
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setContactInfo(car?.car?.owner); }}
                            className="btn btn-sm w-100 mt-1"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal2"
                            style={{ background: "linear-gradient(135deg, #00889c, #006f80)", color: "#fff", borderRadius: "6px", padding: "4px", fontSize: "10px", fontWeight: 600, border: "none" }}
                          >
                            <i className="fa-solid fa-envelope me-1"></i>Contact Seller
                          </button>
                        </div>
                      </div>
                    }
                    hideFooter={true}
                  />
                </div>
              ))
            )}
          </div>
          )}
        </div>
      </div>

      {/* Contact Modal */}
      <div
          className="modal fade"
          id="exampleModal2"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel2"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header pb-0">
                <h4>Contact Details</h4>
              </div>
              <div className="modal-body text-center blue mt-3 contact_modal">
                <h5 className="fs-6 text-capitalized">
                  <b>Name - </b>
                  {contactInfo?.role === "dealer" &&
                    contactInfo?.dealerName !== null &&
                    contactInfo?.dealerName !== ""
                    ? contactInfo?.dealerName
                    : contactInfo?.first_name +
                    " " +
                    (contactInfo?.last_name != null &&
                      contactInfo?.last_name !== "null"
                      ? contactInfo?.last_name
                      : "")}
                </h5>
                <h5 className="fs-6 text-capitalized">
                  <b>Contact - </b>
                  {contactInfo?.phone}
                </h5>
                <Link className="blue ">
                  <h5 className="fs-6 text-capitalized">
                    <b>Email - </b>
                    {contactInfo?.email}
                  </h5>
                </Link>
                <div className="mt-4">
                  <a
                    className="btn btn-primary me-2"
                    href={`tel:+${contactInfo?.phone}`}
                  >
                    <i className="fa fa-phone"></i>
                  </a>
                  <a
                    className="btn btn-info text-white"
                    href={`mailto:${contactInfo?.email}`}
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div>
              </div>

              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  );
};

export default UnlockedCars;
